import styled from "styled-components";

export const UCPListContainer = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  min-height: calc(100vh - 48px - 60px);
  background: ${(props) => props.theme.colors.white};
`;

export const StickyHeaderWrapper = styled.div`
  position: sticky;
  top: 0;
  z-index: 10;
  background: ${(props) => props.theme.colors.white};
  flex-shrink: 0;
`;

export const Content = styled.div`
  flex: 1;
  padding: 32px;
  width: 100%;
  display: flex;
  flex-direction: column;
  background: ${(props) => props.theme.colors.white};
`;

export const ListContent = styled.div`
  margin-top: 24px;
  position: relative;
  flex: 1;
  padding-bottom: 60px;
`;

export const LoaderWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 200px;
`;

export const CardsList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 4px 0;
`;
